<script setup>
import i18n from "@/i18n"
// import Slider from '@vueform/slider'
import { dragRadarChart, initInvisibleGraphic } from "@/utils/dragRadarChart.js";
import { dragRadarChart1, initInvisibleGraphic as initInvisibleGraphic1 } from "@/utils/dragRadarChart1.js";
import { reactive, ref, onMounted, watch, defineEmits, defineExpose, nextTick, inject } from "vue"
import { getProductTemplateMenu } from "@/service";
import { getDatabaseTemplateRadarInfo, database_template_menu_v3_hscoe } from "@/service/apiList/products.js";
import { dragRadarChart3, initInvisibleGraphic as initInvisibleGraphic2, generateInitialData1 as generateInitialData } from '@/utils/dragRadarChart3.js';
import { getLangValue, truncate } from "@/utils/common"; //获取后端语言
import { get_database_radar_map } from "@/service/apiList/products.js"
// import * as echarts from 'echarts';
// import { useRoute } from "vue-router";
// const route = useRoute()
const emits = defineEmits(['search'])
const searchInfo = reactive({
    keyword: '',
    hscode: '',
    hscode_id: '',
    publicType: '',
    production_line_name: '',
    status: '',
    price: [],
    inventory: [],
    hand: [],
    skin: [],
    heat: [],
    art: [],
    productType: '', //产品类型
    layer: 'shell', //结构层
    template_status: '', // 模板禁用状态
})
const showCharts = ref([false, false, false, false]); // 控制4个雷达图的显示
const chart_hand = ref(null)
const chart_hand_dom = ref(null) //手感dom
const checkedHands = ref(false) // 勾选后用于查询信息
const chart_skin = ref(null)
const chart_skin_dom = ref(null) //肤感dom
const checkedSkin = ref(false) // 勾选后用于查询信息
const chart_heat = ref(null)
const chart_heat_dom = ref(null) // 热湿舒适度
const chart_art = ref(null) // 新增美学舒适性
const chart_art_dom = ref(null) // 美学舒适性dom
const showHand = ref(false)
const showSkin = ref(false)
const showHeat = ref(false)
const checkedHeat = ref(false) // 勾选后用于查询信息
const showArt = ref(false) // 美学舒适性
const checkedArt = ref(false) // 勾选后用于查询信息
const radarData = ref({}); //存储雷达图信息
const selectedInfo = inject('selectedInfo')
const shellLsit = ref([]) // 存储外层的数据
const selectedShell = ref('') // 选中的外层
const liningList = ref([]) // 存储内层的数据
const selectedLining = ref('') // 选中的内层
const publicTypeList = [
    {
        label: getLangValue('product-management', "completelypublic"),
        value: 2
    }, {
        label: getLangValue('product-management', "Opasc"),
        value: 3
    },
    {
        label: getLangValue('product-management', "notpublic"),
        value: 1
    },
     {
        label: getLangValue('product-management', "all"),
        value: 4
    },


] //公开类型
// {
//     "id": 0,
//         "name": "待审核"
// },
// {
//     "id": 1,
//         "name": "通过检测"
// },
// {
//     "id": 2,
//         "name": "通过认证"
// },
// {
//     "id": 3,
//         "name": "未通过审核"
// },
// {
//     "id": 4,
//         "name": "更新了HSCode"
// },
// {
//     "id": 5,
//         "name": "更新了模板"
// }
const statusList = [
    { label: getLangValue('business-product', "tab1"), value: 0 },
    { label: getLangValue('business-product', "tab2"), value: 3 },
    { label: getLangValue('business-product', "testedSuccessfully"), value: 1 },
    { label: getLangValue('business-product', "certificationPassed"), value: 2 },
]

const templateStatusList = [
    { label: getLangValue("product-management", "enable"), value: 1 },
    { label: getLangValue("product-management", "disabled"), value: 0 },
    { label: getLangValue("product-management", "all"), value: 2 },
]
const productTypeList = ref([]) // 产品类型
const hscodeList = ref([]); //hscode list
const calbackFunc = (data) => {
    if (data.type == "hand") {
        //  0 1调换位置
        // const [a, b, c, d] = data.data
        // searchInfo.hand = [...[a, a, c, d]];
        searchInfo.hand = [...data.data];
        console.log(searchInfo.hand);
    } else if (data.type == "skin") {
        searchInfo.skin = [...data.data];
    } else if (data.type == "heat") {
        searchInfo.heat = [...data.data];
    } else {
        console.log(data);
        if (data.data.length) {
            searchInfo.art = [...data.data];
        } else {
            initArtChart();
        }

    }
}
const resetChart = (val) => {
    console.log("resetChart", val);
}

const togglechart = (type) => {
    // 收缩图表
    switch (type) {
        case "hand":
            showHand.value = !showHand.value;
            break;
        case "skin":
            showSkin.value = !showSkin.value;
            break;
        case "art":
            showArt.value = !showArt.value;
            break;
        default:
            showHeat.value = !showHeat.value;
            break;
    }
}
//手感chart
const initHandChart = () => {
    if (!showCharts.value[0]) return false
    // console.log(chart_hand.value.offsetWidth);
    if (chart_hand.value) {
        const width = chart_hand.value.offsetWidth;
        const height = chart_hand.value.offsetHeight;
        searchInfo.hand = radarData.value.hand_feeling.map(() => 1)
        let options = {
            indicator: radarData.value.hand_feeling.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.hand_feeling.map(() => 1),
            color: "#50C3E6",
            type: "hand",
            width: width,
            height: height,
            name: getLangValue("radar_chart.feel"),
            chartDom: chart_hand.value,
        };
        chart_hand_dom.value = dragRadarChart(
            options,
            calbackFunc,
            resetChart,
            '22%'
        );
    }
}
// 肤感
const initSkinChart = () => {
    if (!showCharts.value[1]) return false
    if (chart_skin.value) {
        const width = chart_skin.value.offsetWidth;
        const height = chart_skin.value.offsetHeight;
        searchInfo.skin = radarData.value.skin_feeling.map(() => 1)
        let options = {
            indicator: radarData.value.skin_feeling.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.skin_feeling.map(() => 1),
            color: "#13C56B",
            type: "skin",
            width: width,
            height: height,
            name: getLangValue("radar_chart.skin"),
            chartDom: chart_skin.value,
        };
        chart_skin_dom.value = dragRadarChart(
            options,
            calbackFunc,
            resetChart,
            '22%'
        );
    }
}
// 热舒适度
const initHeatChart = () => {
    if (!showCharts.value[2]) return false
    if (chart_heat.value) {
        const width = chart_heat.value.offsetWidth;
        const height = chart_heat.value.offsetHeight;
        searchInfo.heat = radarData.value.heat_and_humidity_comfort.map(() => 1)
        let options = {
            indicator: radarData.value.heat_and_humidity_comfort.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.heat_and_humidity_comfort.map(() => 1),
            color: "#ED5E5E",
            type: "heat",
            width: width,
            height: height,
            name: getLangValue("radar_chart.heat"),
            chartDom: chart_heat.value,
        };
        //   if (
        //     this.handlerClickTable &&
        //     this.currentChoose == "heat" &&
        //     Object.keys(this.chooseTableInfo).length
        //   ) {
        //     options.detailData = [
        //       this.chooseTableInfo.cv_normalized,
        //       this.chooseTableInfo.ds_normalized,
        //       this.chooseTableInfo.ts_normalized,
        //     ];
        //   }
        chart_heat_dom.value = dragRadarChart1(
            options,
            calbackFunc,
            resetChart,
            '26%'
        );
    }

}

// 美学舒适性
const initArtChart = () => {
    if (!showCharts.value[3]) return false
    if (chart_art.value) {
        const width = chart_art.value.offsetWidth;
        const height = chart_art.value.offsetHeight;
        // radarData.value.aesthetic_comfort = [
        //     radarData.value.aesthetic_comfort[0],
        //     radarData.value.aesthetic_comfort[1],
        //     radarData.value.aesthetic_comfort[2],
        //     radarData.value.aesthetic_comfort[3],
        //     radarData.value.aesthetic_comfort[4],
        //     radarData.value.aesthetic_comfort[],
        // ]
        searchInfo.art = radarData.value.aesthetic_comfort.map(() => 1)
        let options = {
            // 动态获取
            indicator: radarData.value.aesthetic_comfort.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.aesthetic_comfort.map(() => 1),
            color: "#ED5E5E",
            type: "art",
            width: width,
            height: height,
            name: getLangValue("radar_chart.art"),
            chartDom: chart_art.value,
        };
        chart_art_dom.value = dragRadarChart3(
            options,
            calbackFunc,
            resetChart,
            '26%'
        );
    }

}

const getTemplateMenu = async () => {
    const resp = await getProductTemplateMenu()
    if (resp.code == 0) {
        productTypeList.value = resp.payload
    }
}

const getHscodeList = async () => {
    // 获取hscode列表
    searchInfo.hscode_id = '';
    // 清空图表
    checkedArt.value = false
    checkedHeat.value = false
    checkedSkin.value = false
    checkedHands.value = false
    showHand.value = false
    showSkin.value = false
    showHeat.value = false
    showArt.value = false
    chart_art_dom.value = null
    chart_skin_dom.value = null
    chart_hand_dom.value = null
    chart_heat_dom.value = null
    // 清空雷达图
    showCharts.value = [false, false, false, false]; // 为空就不显示了
    if (!searchInfo.productType) {
        hscodeList.value = [];
        return
    }
    const resp = await database_template_menu_v3_hscoe(searchInfo.productType);
    if (resp.code == 0) {
        hscodeList.value = resp.payload;
    }
}

// watch(searchInfo, (val) => {
//     emits('search', val);
// })

const initCharts = () => {
    nextTick(() => {
        initHandChart()
        initSkinChart()
        initHeatChart()
    })

}

const getRagarInfo = async () => {
    // 根据产品类型获取雷达图的角标信息
    const resp = await getDatabaseTemplateRadarInfo({ role_key: searchInfo.productType });
    if (resp.code == 0) {
        // 手感 肤感 热舒适度 美学舒适性
        radarData.value = resp.payload;
        const { hand_feeling, skin_feeling, heat_and_humidity_comfort, aesthetic_comfort } = resp.payload;
        if (hand_feeling.length) {
            showCharts.value[0] = true
        }
        if (skin_feeling.length) {
            showCharts.value[1] = true
        }
        if (heat_and_humidity_comfort.length) {
            showCharts.value[2] = true
        }
        if (aesthetic_comfort.length) {
            showCharts.value[3] = true
        }
    }
}

// const getRagarInfo = async () => {
//     // 根据产品类型获取雷达图的角标信息
//     showCharts.value = [false, false, false, false]
//     // 根据t_menuList  获取role_key
//     let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
//     let arr = data.filter(item => item.id === route.params.id)
//     let role_key = arr.length ? arr[0].role_key : '';
//     const resp = await getDatabaseTemplateRadarInfo({ role_key: role_key });
//     if (resp.code == 0) {
//         // 手感 肤感 热舒适度 美学舒适性
//         radarData.value = resp.payload;
//         const { hand_feeling, skin_feeling, heat_and_humidity_comfort, aesthetic_comfort } = resp.payload;
//         if (hand_feeling.length) {
//             showCharts.value[0] = true
//         }
//         if (skin_feeling.length) {
//             showCharts.value[1] = true
//         }
//         if (heat_and_humidity_comfort.length) {
//             showCharts.value[2] = true
//         }
//         // console.log(aesthetic_comfort);
//         if (aesthetic_comfort.length) {
//             showCharts.value[3] = true
//         }
//         // showCharts1.value = radarData.value
//     }
// }

// const getHscodeList = async () => {
//     // 获取hscode列表
//     let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
//     let arr = data.filter(item => item.id === route.params.id)
//     let role_key = arr.length ? arr[0].role_key : '';
//     const resp = await database_template_menu_v3_hscoe(role_key);
//     if (resp.code == 0) {
//         hscodeList.value = resp.payload;
//     }
// }

const update_hand_data = (hand_data) => {
    if (!showHand.value) return
    // 手感数据更新
    const { comprehensive_degree, smooth, soft, warmth } = hand_data.score_hand_feeling || hand_data?.children?.score_hand_feeling || hand_data?.children?.[0].children?.[0].score_hand_feeling || {}
    const hand_feel_data = [
        comprehensive_degree,
        smooth,
        soft,
        warmth,
    ]
    let option = chart_hand_dom.value.getOption();
    let mm = {
        // TODO:
        name: truncate(selectedInfo.value.name),
        value: hand_feel_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: '#70c1e2'
        },
        areaStyle: {
            color: '#70c1e2',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (option.series[1].data.length == 2) {
        option.series[1].data.pop()
    }
    option.series[1].data.push(mm);
    // 更新
    chart_hand_dom.value.setOption(option);
    let data = [
        [0, searchInfo.hand[0]],
        [-searchInfo.hand[1], 0],
        [0, -searchInfo.hand[2]],
        [searchInfo.hand[3], 0]
    ];
    initInvisibleGraphic(chart_hand_dom.value, data, searchInfo.hand, 10, '#50C3E6', 'hand', chart_hand.value.offsetWidth, chart_hand.value.offsetHeight, getLangValue("radar_chart.feel"), calbackFunc);
}

const update_skin_data = (skin_data) => {
    if (!showSkin.value) return
    // 肤感数据更新
    const { comprehensive_degree, cool, pricking, stiff } = skin_data.score_skin_feeling || skin_data?.children?.score_skin_feeling || skin_data?.children?.[0].children?.[0].score_skin_feeling || {}
    const hand_feel_data = [
        comprehensive_degree,
        cool,
        pricking,
        stiff,
    ]
    let option = chart_skin_dom.value.getOption()
    let mm = {
        // TODO:
        name: truncate(selectedInfo.value.name),
        value: hand_feel_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: '#13C56B'
        },
        areaStyle: {
            color: '#13C56B',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (option.series[1].data.length == 2) {
        option.series[1].data.pop()
    }
    option.series[1].data.push(mm);
    // 更新
    chart_skin_dom.value.setOption(option)
    let data = [
        [0, searchInfo.skin[0]],
        [-searchInfo.skin[1], 0],
        [0, -searchInfo.skin[2]],
        [searchInfo.skin[3], 0]
    ];
    initInvisibleGraphic(chart_skin_dom.value, data, searchInfo.skin, 10, '#13C56B', 'skin', chart_skin.value.offsetWidth, chart_skin.value.offsetHeight, getLangValue("radar_chart.skin"), calbackFunc);
}

const update_heat_data = (heat_data) => {
    // 更新热湿舒适度信息
    if (!showHeat.value) return
    // 热��适度数据更新
    const { comfort, heat, humidity } = heat_data.score_heat_and_humidity_comfort
    let heat_and_humidity_comfort_data = [
        comfort,
        heat,
        humidity,
    ]
    // heat_and_humidity_comfort_data = [0.5, 0.5, 0.5]
    let option = chart_heat_dom.value.getOption()
    let mm = {
        // TODO:
        name: truncate(selectedInfo.value.name),
        value: heat_and_humidity_comfort_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: '#ED5E5E'
        },
        areaStyle: {
            color: '#ED5E5E',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (option.series[1].data.length == 2) {
        option.series[1].data.pop()
    }
    option.series[1].data.push(mm);
    // 更新
    chart_heat_dom.value.setOption(option)
    let data = [
        [0, searchInfo.heat[0]],
        [-searchInfo.heat[1], -0.5],
        [searchInfo.heat[2], -0.5],
    ];
    initInvisibleGraphic1(chart_heat_dom.value, data, searchInfo.heat, 10, '#13C56B', 'heat', chart_heat.value.offsetWidth, chart_heat.value.offsetHeight, getLangValue("radar_chart.heat"), calbackFunc);
}

const update_art_data = (art_data) => {
    // 更新美学舒适性
    if (!showArt.value) return
    // 肤感数据更新
    // const { comprehensive_degree, cool, pricking, stiff } = skin_data.score_skin_feeling
    const aesthetic_comfort_data = [...Object.values(art_data?.score_aesthetic_comfort)]
    console.log(aesthetic_comfort_data);
    let option = chart_art_dom.value.getOption()
    let mm = {
        // TODO:
        name: truncate(selectedInfo.value.name),
        value: aesthetic_comfort_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: '#13C56B'
        },
        areaStyle: {
            color: '#13C56B',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (option.series[1].data.length == 2) {
        option.series[1].data.pop()
    }
    option.series[1].data.push(mm);
    // 更新
    chart_art_dom.value.setOption(option)
    // 根据现在的值生成新的坐标
    const { data } = generateInitialData(searchInfo.art)
    initInvisibleGraphic2(chart_art_dom.value, data, searchInfo.art, 10, 'skin', getLangValue("radar_chart.art"), calbackFunc);
}

const getAllRadarInfo = async () => {
    // 获取所有的信息 详情信息  雷达图信息
    // 如果是织物 直接获取数据
    // 如果是服装 需要判断下面有几个织物  一个内外层都是他    多个就要分内外层  切换展示
    if (!showHand.value && !showSkin.value && !showHeat.value && !showArt.value) return false
    const resp = await get_database_radar_map(selectedInfo.value.id)
    // 织物的情况  
    if (resp.payload?.list_hand_feeling?.length == 0 && resp.payload?.list_skin_feeling?.length == 0) {
        // 肯定是织物
        shellLsit.value = [] // 没有内外层
        liningList.value = [] // 没有内外层
        // 就直接使用外层的数据
        // 手感数据
        update_hand_data(resp.payload);
        // 肤感数据
        update_skin_data(resp.payload);
    }
    // 服装的情况
    if (resp.payload?.list_hand_feeling?.length == 1 && resp.payload?.list_skin_feeling?.length == 1) {
        // 服装数据只有一个数据
        shellLsit.value = [] // 没有内外层
        liningList.value = [] // 没有内外层
        // 手感数据
        update_hand_data(resp.payload.list_hand_feeling[0]);
        // 肤感数据
        update_skin_data(resp.payload.list_skin_feeling[0]);
    }
    // 服装的情况 多个织物
    if (resp.payload?.list_hand_feeling?.length > 1 && resp.payload?.list_skin_feeling?.length > 1) {
        // 多个织物  去获取内外层
        // 手感数据
        shellLsit.value = resp.payload.list_hand_feeling?.filter(item => item.layer == 'shell')
        // 肤感数据
        liningList.value = resp.payload.list_skin_feeling?.filter(item => item.layer == 'lining')
        // 手感数据 默认选中第一个
        selectedShell.value = shellLsit.value[0].pid
        update_hand_data(shellLsit.value[0]);
        // 肤感数据 默认选中第一个
        selectedLining.value = liningList.value[0].pid;
        update_skin_data(liningList.value[0]);
    }
    // 服装热湿舒适度  只有服装才有
    if (showCharts.value[2]) {
        // 这个显示了说明有热湿舒适度
        update_heat_data(resp.payload);
    }
    // 展示美学舒适性
    if (resp.payload?.score_aesthetic_comfort) {
        update_art_data(resp.payload)
    }
}

const changeLayer = (type = 1) => {
    // 切换
    if (type == 1) {
        // 手感织物
        let index = shellLsit.value.findIndex(item => item.pid == selectedShell.value)
        index >= 0 && update_hand_data(shellLsit.value[index]);
    } else {
        // 肤感织物
        let index = liningList.value.find(item => item.pid == selectedLining.value)
        index >= 0 && update_skin_data(liningList.value[index]);
    }
}

const changeHand = () => {
    // 切换手感
    // 如果手感为true  其他都为false
    if (checkedHands.value) {
        checkedSkin.value = false
        checkedHeat.value = false
        checkedArt.value = false
        //  图表也有变化
        showHand.value = true
        showSkin.value = false
        showHeat.value = false
        showArt.value = false
        // 清空手感
        selectedInfo.value = { hide: true }
    }
    nextTick(() => {
        if (showHand.value) {
            initHandChart();
        }
        // emits('search', searchInfo);
    })
}

const changeSkin = () => {
    // 切换肤感
    // 如果肤感为true  其他都为false
    if (checkedSkin.value) {
        checkedHands.value = false
        checkedHeat.value = false
        checkedArt.value = false
        //  图表也有变化
        showHand.value = false
        showSkin.value = true
        showHeat.value = false
        showArt.value = false
        // 清空肤感
        selectedInfo.value = { hide: true }
    }
    nextTick(() => {
        if (showSkin.value) {
            initSkinChart();
        }
        // emits('search', searchInfo);
    })
}

const changeHeat = () => {
    // 切换热湿舒适度
    // 如果热湿舒适度为true  其他都为false
    if (checkedHeat.value) {
        checkedHands.value = false
        checkedSkin.value = false
        checkedArt.value = false
        //  图表也有变化
        showHand.value = false
        showSkin.value = false
        showHeat.value = true
        showArt.value = false
        selectedInfo.value = { hide: true }
    }
    nextTick(() => {
        if (showHeat.value) {
            initHeatChart();
        }
        // emits('search', searchInfo);
    })
}
const changeArt = () => {
    // 切换美学舒适度
    // 如果美学舒适度为true  其他都为false
    if (checkedArt.value) {
        checkedHands.value = false
        checkedSkin.value = false
        checkedHeat.value = false
        //  图表也有变化
        showHand.value = false
        showSkin.value = false
        showHeat.value = false
        showArt.value = true
    }
    nextTick(() => {
        if (showArt.value) {
            initArtChart();
        }
        // emits('search', searchInfo);
    })
}

const search = () => {
    // 搜索信息
    emits('search', searchInfo);
}

const reset = () => {
    // 重置
    searchInfo.keyword = ''
    searchInfo.hscode = ''
    searchInfo.role_key = ''
    searchInfo.hscode_id = ''
    searchInfo.productType = ''
    searchInfo.publicType = ''
    searchInfo.status = ''
    searchInfo.price = []
    searchInfo.inventory = []
    searchInfo.hand = []
    searchInfo.skin = []
    searchInfo.heat = []
    searchInfo.art = []
    searchInfo.layer = 'shell' //结构
    searchInfo.production_line_name = ''
    searchInfo.template_status = '' // 模板禁用状态
    // 不展示
    checkedHands.value = false;
    checkedHeat.value = false;
    checkedSkin.value = false;
    checkedArt.value = false;
    emits('search', searchInfo);
}

onMounted(() => {
    //加载chart
    // initCharts()
    // 判断是否显示三个图
    // checkCharts()
    // getProductTemplatePtFun();
    getTemplateMenu();
})

watch(showHand, (val) => {
    if (val) {
        nextTick(() => {
            initHandChart();
        })
    }
})

watch(showSkin, (val) => {
    if (val) {
        nextTick(() => {
            initSkinChart();
        })
    }
})
watch(showHeat, (val) => {
    if (val) {
        nextTick(() => {
            initHeatChart();
        })
    }
})

watch(showArt, (val) => {
    if (val) {
        nextTick(() => {
            initArtChart();
        })
    }
})

watch(() => searchInfo.productType, (val, old) => {
    // 修改逻辑
    if (val == '' || typeof val == 'undefined') {
        showCharts.value = [false, false, false, false]; // 为空就不显示了
    } else {
        if (val && val != old) {
            // 产品类型改变 需要去获取雷达图的信息
            getRagarInfo();
        }
    }
}, { deep: true })

watch(selectedInfo, () => {
    // 如果选择了id  开始切换
    if (selectedInfo.value.id && selectedInfo.value.name) {
        getAllRadarInfo()
    } else {
        // 清空手感
        if (chart_hand_dom.value != null && selectedInfo.value?.hide) {
            let option = chart_hand_dom.value.getOption()
            if (option.series[1].data.length == 2) {
                option.series[1].data.pop()
                chart_hand_dom.value.setOption(option)
            }
        }
        // 清空肤感
        if (chart_skin_dom.value != null && selectedInfo.value?.hide) {
            let option = chart_skin_dom.value.getOption()
            if (option.series[1].data.length == 2) {
                option.series[1].data.pop()
                chart_skin_dom.value.setOption(option)
            }
        }
        // 清空肤感
        if (chart_heat_dom.value != null && selectedInfo.value?.hide) {
            let option = chart_heat_dom.value.getOption()
            if (option.series[1].data.length == 2) {
                option.series[1].data.pop()
                chart_heat_dom.value.setOption(option)
            }
        }
        // 清空空内外层
        shellLsit.value = []
        liningList.value = []
        // 清空美学舒适性
        if (chart_art_dom.value != null && selectedInfo.value?.hide) {
            let option = chart_art_dom.value.getOption()
            if (option.series[1].data.length == 2) {
                option.series[1].data.pop()
                chart_art_dom.value.setOption(option)
            }
        }
    }
})

// 增加监听  勾选了或不勾选需要去查询
// watch(checkedHands, () => {
//     emits('search', searchInfo);
// })

// watch(checkedSkin, () => {
//     emits('search', searchInfo);
// })

// watch(checkedHeat, () => {
//     emits('search', searchInfo);
// })

// watch(checkedArt, () => {
//     emits('search', searchInfo);
// })

defineExpose({
    searchInfo,
    initCharts,
    checkedHands,
    checkedSkin,
    checkedHeat,
    checkedArt,
})
</script>
<template>
    <!-- 搜索条件 -->
    <div class="h-100">
        <div class="my-scroll-bar overflow-auto" style="height: calc(100% - 37.5px - 0.25rem);">
            <!-- 模板禁用状态 -->
            <div class="p-3 pb-0">
                <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                    <span class="text-danger">*</span>
                    {{ getLangValue('product-management.template_status') }}
                </span>
                <div class="pt-3">
                    <el-select style="width: 100%; height: 37.5px;" v-model="searchInfo.template_status" filterable
                        :placeholder="getLangValue('product-management.template_status')" size="mini" clearable>
                        <el-option v-for="(item1, key) in templateStatusList" :key="key" :label="item1.label"
                            :value="item1.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 数据公开类型 -->
            <div class="p-3 pb-0">
                <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                    <span class="text-danger">*</span>
                    {{ $t('product_line.searchPlaceholder1') }}
                </span>
                <div class="pt-3">
                    <el-select style="width: 100%; height: 37.5px;" v-model="searchInfo.productType" filterable
                        :placeholder="$t('product_line.searchPlaceholder1')" size="mini" clearable
                        @change="getHscodeList">
                        <el-option v-for="item1 in productTypeList" :key="item1.key"
                            :label="i18n.global.locale == 'en' ? item1.name_en : item1.name" :value="item1.role_key">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- hscode -->
            <div class="p-3 pb-0">
                <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                    <span class="text-danger">*</span>
                    {{ $t('hscode.name') }}
                </span>
                <div class="pt-3">
                    <!-- <input type="text" class="form-control form-control-sm" v-model="searchInfo.hscode"
                :placeholder="getLangValue('hscode.searchPlaceholder')" /> -->
                    <el-select style="width: 100%; height: 37.5px;" v-model="searchInfo.hscode_id" filterable
                        :placeholder="getLangValue('hscode.searchPlaceholder')" size="mini" clearable>
                        <el-option v-for="(item1, key) in hscodeList" :key="key"
                            :label="i18n.global.locale == 'en' ? item1.title_en : item1.title" :value="item1.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <template v-if="searchInfo.hscode_id">
                <!-- 产品线名称 -->
                <div class="p-3 pb-0">
                    <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">{{ $t('product_line.table_header1')
                        }}</span>
                    <div class="pt-3">
                        <input type="text" class="form-control form-control-sm"
                            v-model="searchInfo.production_line_name"
                            :placeholder="getLangValue('my.product-line', 'seach_product_line_name')" />
                    </div>
                </div>
                <!-- 产品名称 -->
                <div class="p-3 pb-0">
                    <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">{{ $t('products.name') }}</span>
                    <div class="pt-3">
                        <input type="text" class="form-control form-control-sm" v-model="searchInfo.keyword"
                            :placeholder="getLangValue('product-management', 'searchPlaceholder')" />
                    </div>
                </div>
                <!-- 数据公开类型 -->
                <div class="p-3 pb-0">
                    <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">{{ $t('product_template.publicType')
                        }}</span>
                    <div class="pt-3">
                        <el-select style="width: 100%; height: 37.5px;" v-model="searchInfo.publicType" filterable
                            :placeholder="$t('product_template.publicType')" size="mini" clearable>
                            <el-option v-for="item1 in publicTypeList" :key="item1.key" :label="item1.label"
                                :value="item1.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="p-3 pb-0">
                    <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">{{ $t('products.status') }}</span>
                    <div class="pt-3">
                        <el-select style="width: 100%; height: 37.5px;" v-model="searchInfo.status" filterable
                            :placeholder="$t('products.status')" size="mini" clearable>
                            <el-option v-for="item1 in statusList" :key="item1.key" :label="item1.label"
                                :value="item1.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- 价格 -->
                <div class="p-3 pb-0">
                    <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">{{ $t('product_template.price')
                        }}</span>
                    <div class="pt-3">
                        <!-- <Slider v-model="searchInfo.price" :min="0"  :showTooltip="false" style="height: 2px;" /> -->
                        <div class="d-flex justify-content-between my-2 align-items-center">
                            <div class="form-icon">
                                <input v-model="searchInfo.price[0]" type="number"
                                    class="form-control form-control-sm form-control-icon">
                                <!-- <i class="bx bx-dollar"></i> -->
                            </div>
                            <div class="mx-1">-</div>
                            <div class="form-icon">
                                <input v-model="searchInfo.price[1]" type="number"
                                    class="form-control form-control-sm form-control-icon">
                                <!-- <i class="bx bx-dollar"></i> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 库存 -->
                <div class="p-3 pb-0" style="border-bottom: 1px solid rgba(233, 235, 236, 1);">
                    <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">{{
                        $t('product_template.inventory') }}</span>
                    <div class="pt-3">
                        <!-- <Slider v-model="searchInfo.inventory" :min="0" :max="5000" :showTooltip="false" style="height: 2px;" /> -->
                        <div class="d-flex justify-content-between my-2 align-items-center">
                            <div class="form-icon">
                                <input v-model="searchInfo.inventory[0]" type="number"
                                    class="form-control form-control-sm form-control-icon">
                                <!-- <i class="bx bx-dollar"></i> -->
                            </div>
                            <div class="mx-1">-</div>
                            <div class="form-icon">
                                <input v-model="searchInfo.inventory[1]" type="number"
                                    class="form-control form-control-sm form-control-icon">
                                <!-- <i class="bx bx-dollar"></i> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 手感charts -->
                <div class="p-3" style="border-bottom: 1px solid rgba(233, 235, 236, 1);" v-if="showCharts[0]">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer "
                        @click="togglechart('hand')">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                            <input class="form-check-input" v-model="checkedHands" @change="changeHand"
                                @click.stop="() => { }" type="checkbox" role="switch" id="SwitchCheck3" checked>
                            {{ $t('radar_chart.feel') }}</span>
                        <i :class="showHand ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class=""></i>
                    </div>
                    <div class="pt-3" v-show="showHand">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="checkedHands ? '' : 'disabledRadar'">
                            <div class="flex-1 mx-1">
                                <div ref="chart_hand" id="productshandChartId" style="height: 220px; width: 100%">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <!-- 去掉内外层选择  默认手感是外层  肤感是内层 -->
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%;" v-if="shellLsit.length">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{
                                        getLangValue('radar_chart.layer') }}:</span>
                                </div>
                                <el-select style="width: 100%; height: 37.5px;" v-model="selectedShell" filterable
                                    placeholder="" size="mini" @change="changeLayer(1)">
                                    <el-option v-for="(item, key) in shellLsit" :key="key" :label="item.name"
                                        :value="item.pid"></el-option>
                                </el-select>
                            </div>
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.hand_feeling" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.hand[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 肤感charts -->
                <div class="p-3" style="border-bottom: 1px solid rgba(233, 235, 236, 1);" v-if="showCharts[1]">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer "
                        @click="togglechart('skin')">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                            <input class="form-check-input" v-model="checkedSkin" @change="changeSkin"
                                @click.stop="() => { }" type="checkbox" role="switch" id="SwitchCheck3" checked>
                            {{ $t('radar_chart.skin') }}</span>
                        <i :class="showSkin ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class=""></i>
                    </div>
                    <div class="pt-3" v-show="showSkin">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="checkedSkin ? '' : 'disabledRadar'">
                            <div class="flex-1  mx-1">
                                <div ref="chart_skin" id="productskinChartId" style="height: 220px; width: 100%">
                                </div>
                            </div>

                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%;" v-if="liningList.length">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{
                                        getLangValue('radar_chart.layer') }}:</span>
                                </div>
                                <el-select style="width: 100%; height: 37.5px;" v-model="selectedLining" filterable
                                    placeholder="" size="mini" @change="changeLayer(2)">
                                    <el-option v-for="(item, key) in liningList" :key="key" :label="item.name"
                                        :value="item.pid"></el-option>
                                </el-select>
                            </div>
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.skin_feeling" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.skin[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 热舒适度charts -->
                <div class="p-3 " style="border-bottom: 1px solid rgba(233, 235, 236, 1);" v-if="showCharts[2]">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer"
                        @click="togglechart('heat')">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                            <input class="form-check-input" v-model="checkedHeat" @change="changeHeat"
                                @click.stop="() => { }" type="checkbox" role="switch" id="SwitchCheck3" checked>
                            {{ $t('radar_chart.heat') }}</span>
                        <i :class="showHeat ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class=""></i>
                    </div>
                    <div class="pt-3" v-show="showHeat">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="checkedHeat ? '' : 'disabledRadar'">
                            <div class="flex-1">
                                <div ref="chart_heat" id="productheatChartId"
                                    style="height: 220px; width: 100%; min-width: 220px">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.heat_and_humidity_comfort" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.heat[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 美学舒适性charts -->
                <div class="p-3 " style="border-bottom: 1px solid rgba(233, 235, 236, 1);" v-if="showCharts[3]">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer"
                        @click="togglechart('art')">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 12px;">
                            <input class="form-check-input" v-model="checkedArt" @change="changeArt"
                                @click.stop="() => { }" type="checkbox" role="switch" id="SwitchCheck3" checked>
                            {{
                                $t('radar_chart.art') }}</span>
                        <i :class="showHeat ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class=""></i>
                    </div>
                    <div class="pt-3" v-show="showArt">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="checkedArt ? '' : 'disabledRadar'">
                            <div class="flex-1">
                                <div ref="chart_art" id="productartChartId"
                                    style="height: 220px; width: 100%; min-width: 220px">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.aesthetic_comfort" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.art[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="d-flex justify-content-end">
            <b-button variant="success" @click="search" class="w-sm"
                style=" background-color: #405189; display: flex; align-items: center;border-color: unset; justify-content: center;">
                <i class="ri-search-line me-1"></i>{{ getLangValue('base.search') }}
            </b-button>
            <b-button class="mx-2 w-sm" variant="success" @click="reset"
                style="background-color: #299CDB;display: flex; align-items: center;border-color: unset; justify-content: center;">
                <i class="ri-refresh-line me-1"></i> {{ getLangValue('base.reset') }}
            </b-button>
        </div>
    </div>
</template>

<style scoped>
:deep(.slider-handle) {
    width: 12px;
    height: 12px;
    background-color: #51b09d;
    box-shadow: unset;
}

:deep(.el-select__placeholder) {
    font-size: 0.71094rem;
}

.disabledRadar {
    background-color: hsla(0, 0%, 80%, .15);
    pointer-events: none;
    opacity: .3;
    cursor: not-allowed;
}
</style>